// import { authHeader } from '../../helpers';
import axios from "axios";
import { NotificationManager } from "react-notifications";

class Services {
    getToken() {
        let user = JSON.parse(localStorage.getItem("user"));

        if (user && user.token) {
            return user.token;
        }
    }
    headers = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
    };

    httpClient() {
        const instance = axios.create();
        instance.interceptors.request.use(
            async (config) => {
                // Do something before request is sent
                if (this.getToken()) {
                    config.headers = {
                        Authorization: "Bearer " + this.getToken(),
                    };
                }

                return config;
            },
            function (error) {
                // Do something with request error
                return Promise.reject(error);
            }
        );

        instance.interceptors.response.use(
            (response) => {
                return this._handleResponseAPIsuc(response);
            },
            (error) => {
                const status = error?.response?.status || 0;
                if (status === 401) {
                    localStorage.removeItem("user");
                    alert(
                        "ขออภัยสิ้นสุดระยะเวลาการเข้าสู่ระบบ กรุณาเข้าสู่ระบบใหม่อีกครั้ง"
                    );
                    window.location.assign("/member/logon");
                }
                return this._handleResponseAPIerr(error);
            }
        );

        return instance;
    }

    API(url, options) {
        if (this.getToken()) {
            this.headers["Authorization"] = "Bearer " + this.getToken();
        }

        return axios(url, {
            headers: this.headers,
            ...options,
        })
            .then(this._handleResponseAPIsuc)
            .catch(this._handleResponseAPIerr);
    }

    _handleResponseAPIsuc(response) {
        const data = response.data;
        return data;

        // if (response.statusText == "OK") {
        //     return data;
        // }else{
        //     return Promise.reject(data);
        // }
    }

    _handleResponseAPIerr(err) {
        const errors = err.response;
        // if (errors.status === 401) {
        //     location.reload(true);
        // }
        // console.log(errors.data.error);
        if (errors?.data.error) {
            NotificationManager.error(errors.data.error, "Error", 5000);
        }
        const error =
            (errors?.data && errors?.data.message) || errors?.statusText;

        return Promise.reject(error ?? err);
    }
}

export default Services;
